var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/navigation-items.j2"] = require( "macros/navigation-items.j2" );
dependencies["help-navigation/section-header.j2"] = require( "help-navigation/section-header.j2" );
dependencies["help-navigation/section-subitem.j2"] = require( "help-navigation/section-subitem.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["help/templates/help-navigation.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/navigation-items.j2", false, "help/templates/help-navigation.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("renderNavItem")) {
var t_4 = t_1.renderNavItem;
} else {
cb(new Error("cannot import 'renderNavItem'")); return;
}
context.setVariable("renderNavItem", t_4);
output += "\n\n<nav class=\"o-column o-extra-small--12 o-medium--3 o-large--2 dom-help-navigation\" aria-label=\"";
output += runtime.suppressValue((lineno = 2, colno = 96, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["help__navigation-aria-label"])), env.opts.autoescape);
output += "\">\n\n    <div class=\"s-category-navigation o-secondary-navigation-inner js-dropdown-container\"  data-qa-help-nav-container>\n\n    ";
var t_5;
t_5 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "help")),"navRootSlug"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "help")),"slug")));
frame.set("rootNavItem", t_5, true);
if(frame.topLevel) {
context.setVariable("rootNavItem", t_5);
}
if(frame.topLevel) {
context.addExport("rootNavItem", t_5);
}
output += "\n\n    ";
var t_6;
t_6 = (runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_extra_small") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_small")?runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "help")),"slug")):runtime.contextOrFrameLookup(context, frame, "rootNavItem"));
frame.set("sectionHeaderNavItem", t_6, true);
if(frame.topLevel) {
context.setVariable("sectionHeaderNavItem", t_6);
}
if(frame.topLevel) {
context.addExport("sectionHeaderNavItem", t_6);
}
output += "\n\n    ";
env.getTemplate("help-navigation/section-header.j2", false, "help/templates/help-navigation.j2", null, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
t_7.render(context.getVariables(), frame, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
output += t_8
output += "\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "rootNavItem") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rootNavItem")),"childSlugs") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rootNavItem")),"childSlugs")) > 0) {
output += "\n\n        <ul class=\"o-secondary-navigation__ul js-accordion\">\n\n        ";
frame = frame.push();
var t_13 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rootNavItem")),"childSlugs");
if(t_13) {var t_12 = t_13.length;
for(var t_11=0; t_11 < t_13.length; t_11++) {
var t_14 = t_13[t_11];
frame.set("sectionItemSlug", t_14);
frame.set("loop.index", t_11 + 1);
frame.set("loop.index0", t_11);
frame.set("loop.revindex", t_12 - t_11);
frame.set("loop.revindex0", t_12 - t_11 - 1);
frame.set("loop.first", t_11 === 0);
frame.set("loop.last", t_11 === t_12 - 1);
frame.set("loop.length", t_12);
output += "\n\n            ";
var t_15;
t_15 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_14);
frame.set("sectionItemNavItem", t_15, true);
if(frame.topLevel) {
context.setVariable("sectionItemNavItem", t_15);
}
if(frame.topLevel) {
context.addExport("sectionItemNavItem", t_15);
}
output += "\n\n            ";
env.getTemplate("help-navigation/section-subitem.j2", false, "help/templates/help-navigation.j2", null, function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
t_16.render(context.getVariables(), frame, function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
output += t_17
output += "\n\n        ";
})});
}
}
frame = frame.pop();
output += "\n\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "help")),"slug") != runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "help")),"navRootSlug") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish")) {
output += "\n\n            ";
var t_20;
t_20 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "help")),"navRootSlug"));
frame.set("sectionItemNavItem", t_20, true);
if(frame.topLevel) {
context.setVariable("sectionItemNavItem", t_20);
}
if(frame.topLevel) {
context.addExport("sectionItemNavItem", t_20);
}
output += "\n\n            ";
env.getTemplate("help-navigation/section-subitem.j2", false, "help/templates/help-navigation.j2", null, function(t_23,t_21) {
if(t_23) { cb(t_23); return; }
t_21.render(context.getVariables(), frame, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
output += t_22
output += "\n\n        ";
})});
}
output += "\n\n        </ul>\n\n    ";
;
}
output += "\n\n    </div>\n\n</nav>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["help/templates/help-navigation.j2"] , dependencies)